import { render, staticRenderFns } from "./SidebarNavigationGroupLink.vue?vue&type=template&id=7fb1025c"
import script from "./SidebarNavigationGroupLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavigationGroupLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports